module.exports = __webpack_public_path__ + "Flag-250.0eb1d0c8209c6dd15a15a7e049ca4228.svg";